import { observer } from 'mobx-react-lite';
import { PropsWithChildren, ReactNode } from 'react';

import { useUserStore } from '@/configs/store';
import { useGlobalUserFilterModel } from '@/features/globalUserFilter';
import { useIsLogsReadOnly } from '@/features/logsMode';

type Props = PropsWithChildren<{
  loadingFallback?: ReactNode;
  fallback?: ReactNode;
}>;

const ReadonlyGuard = ({ children, loadingFallback, fallback }: Props) => {
  const { isLoading: isUserLoading, user: currentUser, isAdmin } = useUserStore();
  const { loadingStage, isViewingSelf } = useGlobalUserFilterModel();
  const isLogsReadOnly = useIsLogsReadOnly();

  if (isUserLoading || loadingStage.isLoading) {
    return loadingFallback || null;
  }

  // Собственный учёт пока только для просмотра — как чужие логи, даже админу
  if (!currentUser || isLogsReadOnly) {
    return fallback || null;
  }

  if (!isViewingSelf && !isAdmin) {
    return fallback || null;
  }

  return children;
};

export default observer(ReadonlyGuard);
